import type { FC } from 'react';

import { CreditWarningBar as CreditWarningBarPrimitive } from '@eneco/custom-components/CreditWarningBar';

/**
 * `CreditWarningBar` block for the CMS-agnostic lane, serving **both** providers.
 *
 * Mirrors the legacy Sitecore lane (`libs/sitecore/components/content/src/CreditWarningBar/
 * CreditWarningBar.tsx`): a fixed, legally-mandated "borrowing money costs money" bar. The legacy
 * component reads no CMS fields at all (`libs/sitecore/types/CreditWarningBar.d.ts` declares
 * `fields: {}`), and the migration bundle's `CreditWarningBar` section confirms the same — so this
 * block takes no content and needs no `useContent()` call.
 *
 * The styled body lives in `libs/custom-components/src/CreditWarningBar` — its border and font are
 * fixed by the AFM's mandated look rather than Sparky tokens, so it can't live directly in this lane
 * (`dxp-rules/no-custom-styling`).
 */
const CreditWarningBar: FC = () => <CreditWarningBarPrimitive />;

export default CreditWarningBar;
